// src/config/axiosConfig.js
import axios from 'axios';

// Set default timeout for all axios requests
axios.defaults.timeout = 30000; // 30 seconds

// Enable credentials for all requests (for session cookies)
axios.defaults.withCredentials = true;

// Add request interceptor for logging and URL fixing
axios.interceptors.request.use(
  (config) => {
    // Fix any double /api issues in the URL
    if (config.url && config.url.includes('/api/api/')) {
      const fixedUrl = config.url.replace('/api/api/', '/api/');

      config.url = fixedUrl;
    }
    
    // Log the request URL in development
    if (process.env.NODE_ENV !== 'production') {
      console.log(`[Axios Request] ${config.url}`);
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Log detailed error information
    if (process.env.NODE_ENV !== 'production') {
      console.error('API Error:', {
        url: error.config?.url,
        method: error.config?.method,
        status: error.response?.status,
        statusText: error.response?.statusText,
        message: error.message,
        code: error.code
      });
    }
    
    // Add custom error handling
    if (error.code === 'ECONNABORTED') {
      error.customMessage = 'Request timed out. Please try again later.';
    } else if (error.response && error.response.status === 504) {
      error.customMessage = 'Gateway timeout. The server might be unavailable.';
    } else if (!navigator.onLine) {
      error.customMessage = 'You appear to be offline. Please check your internet connection.';
    }
    
    // Handle OTP-related errors
    if (error.response && error.response.data && error.response.data.message) {
      const message = error.response.data.message;
      
      // Session expiration errors
      if (message.includes('no verification code found') || message.includes('session')) {
        error.customMessage = 'Session expired. Please request a new verification code.';
      }
      
      // Email/SMTP errors
      else if (message.includes('email service') || message.includes('send verification email')) {
        error.customMessage = 'Unable to send email. Please try again later or contact support.';
      }
      
      // Rate limiting
      else if (message.includes('too many') || message.includes('rate limit')) {
        error.customMessage = 'Too many attempts. Please wait before trying again.';
      }
    }
    
    // Detect CORS-related failures
    if (error.message && error.message.includes('CORS')) {
      console.error('CORS Error detected. Check backend CORS configuration.');
      error.customMessage = 'Cross-origin request failed. Please contact support.';
    }
    
    return Promise.reject(error);
  }
);

export default axios;
